import { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  // === Public routes (AuthLayout wraps q-page) ===
  {
    path: '/login',
    component: () => import('layouts/AuthLayout.vue'),
    children: [
      {
        path: '',
        name: 'login',
        component: () => import('pages/auth/LoginPage.vue'),
      },
    ],
  },
  {
    path: '/register',
    component: () => import('layouts/AuthLayout.vue'),
    children: [
      {
        path: '',
        name: 'register',
        component: () => import('pages/auth/RegisterPage.vue'),
      },
    ],
  },

  // === Protected routes (with MainLayout) ===
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      // --- Dashboard ---
      {
        path: '',
        name: 'dashboard',
        component: () => import('pages/DashboardPage.vue'),
        meta: { resource: 'dashboard' },
      },

      // --- Profile ---
      {
        path: 'profile',
        name: 'profile',
        component: () => import('pages/ProfilePage.vue'),
        meta: { resource: 'profile' },
      },

      // --- Formacion ---
      {
        path: 'courses',
        name: 'courses',
        component: () => import('pages/CoursesPage.vue'),
        meta: { resource: 'courses' },
      },
      {
        path: 'courses/:slug',
        name: 'course-detail',
        component: () => import('pages/CourseDetailPage.vue'),
        meta: { resource: 'courses' },
      },
      {
        path: 'learn',
        name: 'learn',
        redirect: '/courses',
        meta: { resource: 'learn' },
      },
      {
        path: 'learn/:courseId',
        name: 'learn-course',
        component: () => import('pages/LearnCoursePage.vue'),
        meta: { resource: 'learn' },
      },
      {
        path: 'learn/:courseId/lesson/:lessonId',
        name: 'lesson',
        component: () => import('pages/LessonPage.vue'),
        meta: { resource: 'learn' },
      },

      // --- Admin ---
      {
        path: 'admin',
        name: 'admin',
        component: () => import('pages/AdminPage.vue'),
        meta: { resource: 'admin' },
      },
      {
        path: 'admin/users',
        name: 'admin-users',
        component: () => import('pages/AdminUsersPage.vue'),
        meta: { resource: 'admin' },
      },
      {
        path: 'admin/users/:userId',
        name: 'admin-student-ficha',
        component: () => import('pages/AdminStudentFichaPage.vue'),
        meta: { resource: 'admin' },
      },
      {
        path: 'admin/courses',
        name: 'admin-courses',
        component: () => import('pages/AdminCoursesPage.vue'),
        meta: { resource: 'admin' },
      },
      {
        path: 'admin/courses/new',
        name: 'admin-course-new',
        component: () => import('pages/AdminCourseFormPage.vue'),
        meta: { resource: 'admin' },
      },
      {
        path: 'admin/courses/:id/edit',
        name: 'admin-course-edit',
        component: () => import('pages/AdminCourseEditPage.vue'),
        meta: { resource: 'admin' },
      },
      {
        path: 'admin/courses/:id/lessons/:lid',
        name: 'admin-lesson-editor',
        component: () => import('pages/AdminLessonEditorPage.vue'),
        meta: { resource: 'admin' },
      },
    ],
  },

  // === Catch-all 404 ===
  {
    path: '/:catchAll(.*)*',
    name: 'not-found',
    component: () => import('pages/NotFoundPage.vue'),
  },
];

export default routes;
